import * as actionTypes from './actionTypes'

const initialState = { 
  warehouse: false, 
  warehouseProducts : false,
} 
const reducer =  (state = initialState, action) => {
    switch (action.type) { 
        case actionTypes.SET_WAREHOUSE:
            return {...state,warehouse: action.payload}
        case actionTypes.SET_WAREHOUSE_PRODUCTS:
            return {...state,warehouseProducts: action.payload}
        default:
            return state
    }
}

export default reducer;